import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import ErrorTechnical from "../common/page/errorEechnical";

import SanctionLetterApproval from "./pages/sanctionLetterApproval";

const FintechRoute = () => (
    <Router basename="/fintech">
        <Switch>
            <Route
                exact
                path="/sanction-letter-approval"
                component={SanctionLetterApproval}
            />
            <Route exact path="/error" component={ErrorTechnical} />
            <Route exact>
                <h1>404 not Found</h1>
            </Route>
        </Switch>
    </Router>
);

export default FintechRoute;
